const kr = {
    translation:
    {
        "Active": "활성화",
        "Active Campaigns": "활성 캠페인",
        "Add New Account": "새 계정 추가",
        "Add Task": "작업 추가",
        "Add new": "새로 추가",
        "Add the new URL": "새로운 URL 추가",
        "Add the new keyword": "새로운 키워드 추가",
        "Add the new tag": "새로운 태그 추가",
        "Advance Options": "고급 옵션",
        "Advance Setting": "고급 설정",
        "Advanced Clicking": "고급 클릭",
        "Advanced Functions": "고급 기능",
        "Advanced Image Editor": "고급 이미지 편집기",
        "All": "모두",
        "All settings": "모든 설정",
        "An unexpected error has occurred": "예기치 못한 오류가 발생했습니다",
        "Are you sure to clear all caches?": "모든 캐시를 지우시겠습니까?",
        "Are you sure to clear the accounts list?": "계정 목록을 지우시겠습니까?",
        "Are you sure to clone this campaign?": "이 캠페인을 복제하시겠습니까?",
        "Are you sure to delete this campaign?": "이 캠페인을 삭제하시겠습니까?",
        "Are you sure to delete this thread?": "이 스레드를 삭제하시겠습니까?",
        "Are you sure to remove the campaign(s)?": "이 캠페인(들)을 삭제하시겠습니까?",
        "Are you sure to remove the proxies?": "프록시를 삭제하시겠습니까?",
        "Are you sure to reset settings?": "설정을 재설정하시겠습니까?",
        "Are you sure to restart the campaign(s)?": "이 캠페인(들)을 다시 시작하시겠습니까?",
        "Are you sure to these changes?": "이 변경 사항을 저장하시겠습니까?",
        "Attribute": "속성",
        "Available days": "사용 가능한 일수",
        "Avg Daily Visitors": "평균 일일 방문자 수",
        "Avg Visitor Duration": "평균 방문자 지속 시간",
        "Back": "뒤로",
        "Back To Campaigns": "캠페인으로 돌아가기",
        "Block Images": "이미지 차단",
        "Block Resources": "리소스 차단",
        "Block the campaign until VPN gets connected": "VPN이 연결될 때까지 캠페인 차단",
        "Browse Result Pages": "결과 페이지 찾아보기",
        "Browser Profile": "브라우저 프로필",
        "Browser Type": "브라우저 유형",
        "Buy a license key": "라이선스 키 구매",
        "CTR": "CTR",
        "CType": "CType",
        "Cache cleared successfully": "캐시가 성공적으로 지워졌습니다",
        "Calendar": "캘린더",
        "Camp Settings": "캠페인 설정",
        "Campaign name": "캠페인 이름",
        "Campaign to clone": "복제할 캠페인",
        "Campaigns": "캠페인",
        "Chance": "기회",
        "Change point": "포인트 변경",
        "Changed successfully": "성공적으로 변경되었습니다",
        "Choose": "선택",
        "Choose an action": "동작 선택",
        "Choose file": "파일 선택",
        "Choose the file to import": "가져올 파일 선택",
        "Clear": "지우기",
        "Clear List": "목록 지우기",
        "Clear all caches": "모든 캐시 지우기",
        "Click Here": "여기를 클릭하세요",
        "Click on the map and move the pointer": "지도를 클릭하고 포인터를 이동하세요",
        "Clicking Chance (CTR)": "클릭 기회 (CTR)",
        "Clone": "복제",
        "Clone Selected": "선택한 항목 복제",
        "Complete": "완료",
        "Congratulations": "축하합니다",
        "Connect your device to your computer/laptop via USB": "USB를 통해 기기를 컴퓨터/노트북에 연결하세요",
        "Connection Type": "연결 유형",
        "Copyright DalgaDev": "저작권 DalgaDev",
        "Country": "국가",
        "Create new Campaign": "새 캠페인 생성",
        "Created Campaigns": "생성된 캠페인",
        "Creation Date": "생성 일자",
        "Custom CSS Selector (it will ignore the settings made above)": "사용자 정의 CSS 선택기 (위에서 설정한 내용을 무시합니다)",
        "Custom Xpath Selector (it will ignore the settings made above)": "사용자 정의 XPath 선택기 (위에서 설정한 내용을 무시합니다)",
        "Dashboard": "대시보드",
        "Dear User": "친애하는 사용자",
        "Debug Logs": "디버그 로그",
        "Delay Between": "지연 시간",
        "Delay between campaigns": "캠페인 간 지연 시간",
        "Delay on the main webpage": "주 웹페이지에서의 지연 시간",
        "Description about latest camps and more …": "최신 캠페인 및 기타에 대한 설명 …",
        "Desktop": "데스크톱",
        "Device Name": "장치 이름",
        "Devices": "장치",
        "Direct Traffic": "직접 트래픽",
        "Do you want the accounts of this profile to be replaced by the following accounts?": "이 프로필의 계정을 다음 계정으로 교체하시겠습니까?",
        "Do you want to save the accounts on the selected profile before closing the window?": "창을 닫기 전에 선택한 프로필의 계정을 저장하시겠습니까?",
        "Don't block in these urls": "이 URL에서 차단하지 마세요",
        "Edit": "편집",
        "Edit Image": "이미지 편집",
        "Edit Selected": "선택한 항목 편집",
        "Edit Task": "작업 편집",
        "Edit in bulk": "대량 편집",
        "Element": "요소",
        "Email": "이메일",
        "Enter RSS feed URL here": "여기에 RSS 피드 URL 입력",
        "Enter Sitemap URL here": "여기에 사이트맵 URL 입력",
        "Enter group name": "그룹 이름 입력",
        "Enter the URL to import": "가져올 URL 입력",
        "Enter the port": "포트 입력",
        "Enter your license key": "라이선스 키 입력",
        "Error": "오류",
        "Explore key details about your most recent campaigns": "가장 최근 캠페인에 대한 주요 세부 정보 탐색",
        "Export": "내보내기",
        "External links": "외부 링크",
        "Fast": "빠름",
        "Features & Actions": "기능 및 동작",
        "Fix Error": "오류 수정",
        "From": "시작일",
        "Full debugging mode": "전체 디버깅 모드",
        "GO BACK": "뒤로 가기",
        "GPS Simulation": "GPS 시뮬레이션",
        "Generate Selectors Automatically": "자동으로 선택기 생성",
        "Go to Campaigns": "캠페인으로 이동",
        "Google Account": "Google 계정",
        "Google Map": "Google 지도",
        "How many pages should the bot visit in each session?": "각 세션에서 봇이 방문해야 할 페이지 수는 얼마인가요?",
        "How many seconds should IP visit other subpage?": "IP가 다른 하위 페이지를 방문하는 데 몇 초가 소요될까요?",
        "How would you like threads to operate?": "스레드를 어떻게 작동시키고 싶으세요?",
        "I accept the agreement": "계약을 수락합니다",
        "If a configuration file doesn't work skip it and try another file": "구성 파일이 작동하지 않으면 건너뛰고 다른 파일을 시도하세요",
        "Import": "가져오기",
        "Import (Seperate by line)": "가져오기 (줄 바꿈으로 구분)",
        "Import From File": "파일에서 가져오기",
        "Import Options": "가져오기 옵션",
        "Import Proxy": "프록시 가져오기",
        "Import selected": "선택한 항목 가져오기",
        "Import the websites in bulk (Seperate by line)": "웹 사이트 대량 가져오기 (줄 바꿈으로 구분)",
        "Imported successfully": "성공적으로 가져왔습니다",
        "Inactive": "비활성",
        "Input your text": "텍스트를 입력하세요",
        "Internal links": "내부 링크",
        "Keyword": "키워드",
        "Keywords": "키워드",
        "Lan": "언어",
        "Last Status": "최근 상태",
        "Latest Campaigns": "최신 캠페인",
        "Learn More": "더 알아보기",
        "Less": "덜",
        "License": "라이선스",
        "License Key": "라이선스 키",
        "Link": "링크",
        "Load File": "파일 불러오기",
        "Load URL": "URL 불러오기",
        "Log all activities": "모든 활동 기록",
        "Logout": "로그아웃",
        "Make sure at least one task is added": "적어도 하나의 작업이 추가되었는지 확인하세요",
        "Manage Account": "계정 관리",
        "Message": "메시지",
        "Mobile": "모바일",
        "Mode": "모드",
        "Modify": "수정",
        "More": "더 많이",
        "Multi Thread": "멀티 스레드",
        "Multi Threading": "멀티 스레딩",
        "Name": "이름",
        "Name Of Business": "비즈니스 이름",
        "Never show notification at top": "알림을 항상 맨 위에 표시하지 않음",
        "New Task": "새 작업",
        "Newest": "가장 최신",
        "No Keyword/websites were found to import": "가져올 키워드/웹사이트를 찾을 수 없습니다",
        "No file chosen": "선택된 파일이 없습니다",
        "No thread found": "스레드를 찾을 수 없습니다",
        "NordVPN": "NordVPN",
        "Notifications": "알림",
        "Number of visitors": "방문자 수",
        "OR": "또는",
        "Oldest": "가장 오래된",
        "OpenVPN files directory": "OpenVPN 파일 디렉토리",
        "Order By": "정렬 기준",
        "Other VPN (Manual)": "다른 VPN (수동)",
        "Overview": "개요",
        "Overwrite": "덮어쓰기",
        "Pages": "페이지",
        "Password": "비밀번호",
        "Please accept the agreement": "계약을 수락하세요",
        "Please choose the mode you want to use": "사용하려는 모드를 선택하세요",
        "Please fill the format and protocol": "형식과 프로토콜을 입력하세요",
        "Please try using other methods, although this method will still be available in the next few updates": {
            " But we’re going to deprecate this method soon": {
                "": ""
            }
        },
        "Point set successfully!": "점이 성공적으로 설정되었습니다!",
        "Port": "포트",
        "Previous Step": "이전 단계",
        "Profiles": "프로필",
        "Protocol": "프로토콜",
        "Proxy": "프록시",
        "Put the app in windows start up": "앱을 Windows 시작 프로그램으로 설정하세요",
        "Quick Update": "빠른 업데이트",
        "Reactive the bot with another purchase code": "다른 구매 코드로 봇을 재활성화하세요",
        "Recent logs": "최근 로그",
        "Recovery Email": "복구 이메일",
        "Remove": "제거",
        "Remove All": "모두 제거",
        "Remove Group": "그룹 제거",
        "Remove Selected": "선택한 항목 제거",
        "Remove non-functional proxies": "작동하지 않는 프록시 제거",
        "Remove this device from the license key": "이 장치를 라이선스 키에서 제거하세요",
        "Report": "보고서",
        "Reset and clear all campaigns and their settings": "모든 캠페인 및 설정을 재설정 및 지우세요",
        "Restart": "다시 시작",
        "Restart All": "모두 다시 시작",
        "Restart Selected": "선택한 항목 다시 시작",
        "SE": "검색 엔진",
        "Save": "저장",
        "Save Profile": "프로필 저장",
        "Saved successfully": "성공적으로 저장되었습니다",
        "Schedule": "일정",
        "Scheduled Camp": "예약된 캠페인",
        "Scroll": "스크롤",
        "Search": "검색",
        "Search Engine": "검색 엔진",
        "Search Engine Domain": "검색 엔진 도메인",
        "Search Language": "검색 언어",
        "Seconds": "초",
        "See All Notifications": "모든 알림 보기",
        "Select Airplane mode icon": "비행기 모드 아이콘 선택",
        "Select Airplane mode icon on ATB": "ATB에서 비행기 모드 아이콘 선택",
        "Select Campaign": "캠페인 선택",
        "Select Edit Mode": "편집 모드 선택",
        "Select Profile Name": "프로필 이름 선택",
        "Select a profile or enter a new profile name": "프로필을 선택하거나 새 프로필 이름을 입력하세요",
        "Select from": "다음에서 선택",
        "Select or enter a new profile": "프로필을 선택하거나 새 프로필 이름을 입력하세요",
        "Select the website that you want visitors to be referred from": "방문자를 참조하려는 웹 사이트를 선택하세요",
        "Sent Visitors": "보낸 방문자",
        "Sent views": "보낸 뷰",
        "Session": "세션",
        "Settings": "설정",
        "Settings reset successfully": "설정이 성공적으로 재설정되었습니다",
        "Slow": "느린",
        "Social Media": "소셜 미디어",
        "Sorry, page not found!": "죄송합니다. 페이지를 찾을 수 없습니다!",
        "Speed": "속도",
        "Start": "시작",
        "Start All": "모두 시작",
        "Start Minimized": "최소화된 상태로 시작",
        "Start Selected": "선택한 항목 시작",
        "Start sending traffic as soon as the app comes up": "앱이 실행되면 즉시 트래픽을 보내기 시작하세요",
        "Statistics": "통계",
        "Status": "상태",
        "Stop": "정지",
        "Stop All": "모두 정지",
        "Stop Selected": "선택한 항목 정지",
        "Submit": "제출",
        "THIS OPTION IS GOING TO DEPRECATE SOON": {
            "": ""
        },
        "Tablet": "태블릿",
        "Tags": "태그",
        "Task Not Found": "작업을 찾을 수 없습니다",
        "Tasks": "작업",
        "Test Proxy": "프록시 테스트",
        "Test Proxy Result": "프록시 테스트 결과",
        "The action was successfully done": "동작이 성공적으로 수행되었습니다",
        "The bot was deactivated": "봇이 비활성화되었습니다",
        "The campaign cloned successfully": "캠페인이 성공적으로 복제되었습니다",
        "The campaign has been modified": {
            " Click to save the changes": " 변경 사항을 저장하려면 클릭하세요"
        },
        "The campaign(s) removed successfully": "캠페인(들)이 성공적으로 제거되",
        "No notification found": "알림이 없습니다",
        "Logs": "로그",
        "Threads": "쓰레드",
        "About": "정보",
        "Help": "도움말",
        "Search Engine Traffic": "검색 엔진 트래픽",
        "URL": "URL",
        "What do you want to export?": "무엇을 내보내시겠습니까?",
        "Visitor": "방문자",
        "Sleeping": "대기 중",
        "Total Visitors": "총 방문자 수",
        "Type": "유형",
        "Not Found": "찾을 수 없음",
        "For instance: if you have 30 campaigns to send traffic to and you choose 30 threads,": "예를 들어: 30 개의 캠페인이 있고 30 개의 쓰레드를 선택하면,",
        "each thread will initiate from the first campaign and it will process campaigns until the last one.": "각 쓰레드는 첫 번째 캠페인에서 시작하여 마지막 캠페인까지 처리합니다.",
        "each thread will have a different campaign assigned (first thread will send traffic to the first campaign,": "각 쓰레드는 다른 캠페인이 할당됩니다 (첫 번째 쓰레드는 첫 번째 캠페인으로 트래픽을 보냅니다.",
        "second thread to the second campaign, and so forth)": "두 번째 쓰레드는 두 번째 캠페인으로 이동하고 이렇게 반복됩니다)",
        "This field must be filled in!": "이 필드는 채워져야 합니다!",
        "Update Campaign": "캠페인 업데이트",
        "What we should call your campaign and more …": "캠페인에 대해 어떻게 부를지 및 기타 …",
        "User-agent Device Percentage": "사용자 에이전트 장치 비율",
        "Unlimited": "무제한",
        "To": "To",
        "Image": "이미지",
        "Video and Audio": "비디오 및 오디오",
        "Font": "글꼴",
        "Script (js codes)": "스크립트 (JS 코드)",
        "CSS (Stylesheet)": "CSS (스타일시트)",
        "What to do?": "무엇을 할까요?",
        "What to do with browser directories?": "브라우저 디렉터리에 대해 어떻게 할까요?",
        "Next Step": "다음 단계",
        "Your campaign is updated successfully": "캠페인이 성공적으로 업데이트되었습니다",
        "Visit": "방문",
        "referrer": "리퍼러",
        "Update Camp": "캠프 업데이트",
        "no directory chosen": "디렉토리를 선택하지 않았습니다",
        "You need to download openvpn files (configs) from your VPN's website and place the config files into a directory and select it by the ATB": "VPN 웹 사이트에서 OpenVPN 파일(configs)을 다운로드하고 구성 파일을 디렉토리에 넣은 다음 ATB로 선택해야 합니다",
        "Username": "사용자 이름",
        "Please follow these steps to configure your android phone to use it with the bot:": "봇과 함께 사용하려면 안드로이드 폰을 구성하는 방법을 따라 주십시오:",
        "Turn On USB Debugging ( and USB Security Debugging on Xiaomi Phones ).": "USB 디버깅을 켜십시오 (샤오미 폰의 경우 USB 보안 디버깅도 함께 켜십시오).",
        "Accept Authorization Request on your mobile. ( Select Always Checkbox as well)": "모바일에서 승인 요청을 수락하십시오. (항상 확인란도 선택하십시오)",
        "Wait time between toggling airplan mode (seconds)": "비행기 모드를 전환하는 간격 시간(초)",
        "Turn Off Your WiFi and Turn On USB Tethering": "WiFi를 끄고 USB 테더링을 켜십시오",
        "Ensure your phone screen stays active while using the application.":"애플리케이션 사용 중에 핸드폰 화면이 계속 활성화되도록 보장하세요.",
        "Your Device model is {{deviceName}} with android version {{version}} and not rooted": "귀하의 기기 모델은 {{deviceName}}이며 Android 버전은 {{version}}이며 루팅되지 않았습니다",
        "Are you sure you want to deactivate the bot on this device? This will not remove the device from activated devices list.": "이 기기에서 봇을 비활성화하시겠습니까? 이로 인해 기기가 활성화된 기기 목록에서 제거되지 않습니다.",
        "No": "아니오",
        "Yes": "예",
        "Enter your license key or purchase code.": "라이선스 키 또는 구매 코드를 입력하십시오.",
        "Verify": "확인",
        "Actions to Perform on the Maps Listing":"지도 목록에서 수행할 작업",
        "Business Name":"사업 이름"                        
    }
}

export default kr;